import { atom } from 'jotai'

type Input = {
  // NOTE: 開いている途中・閉じている途中、といった状態を欲しくなる可能性があるため、stateという形で定義
  state: 'opened' | 'closed'
}

const state = atom<Input>({
  state: 'closed',
})
export const sidePanelLayoutStore = { state } as const
